import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

// Basic (Visitor)
import HomePage from "../views/HomePage";
import SearchMentor from "../views/SearchMentor";
import FAQPage from "../views/FAQPage"
import AboutPage from "../views/AboutPage";
import LoginPage from "../views/LoginPage";
import RegisterPage from "../views/RegisterPage";
import VerifyTokenPage from "../views/VerifyTokenPage";
import ForgotPasswordPage from "../views/ForgotPasswordPage";

// Common
import ChangePasswordPage from "../views/common/ChangePasswordPage";

// Mentor
import MentorBasePage from "../views/mentor/MentorBasePage";
import MentorProfilePage from "../views/mentor/MentorProfilePage";
import MentorProfileSettingsPage from "../views/mentor/MentorProfileSettingsPage";
import MentorPendingRequestsPage from "../views/mentor/MentorPendingRequestsPage";
import MyMenteesPage from "../views/mentor/MyMenteesPage";
import MentorSettingsPage from "../views/mentor/MentorSettingsPage";
import MentorMessages from "../views/mentor/MentorMessages";

// Mentee
import MenteeBasePage from "../views/mentee/MenteeBasePage";
import MenteeProfilePage from "../views/mentee/MenteeProfilePage";
import MenteeRequestProfilePage from "../views/mentee/MenteeRequestProfilePage";
import MenteeProfileSettingsPage from "../views/mentee/MenteeProfileSettingsPage";
import MenteePendingRequestsPage from "../views/mentee/MenteePendingRequestsPage";
import MyMentorsPage from "../views/mentee/MyMentorsPage";
import FindMentorPage from "../views/mentee/FindMentorPage";
import RfcLandingPage from "../views/rfc/VerifyMentorPage";
import MenteeMessages from "../views/mentee/MenteeMessages.vue"

// Mentorship
import MentorshipPage from "../views/mentorship/MentorshipPage";

//Rfc
import MentorAnalyticsPage from "../views/rfc/MentorAnalyticsPage";
import MenteesPage from "../views/rfc/MenteesPage"
import VerifyMentorPage from "../views/rfc/VerifyMentorPage";
import RfcBasePage from "../views/rfc/RfcBasePage";
import RfcMessages from "../views/rfc/RfcMessages.vue"
import Terms from "../views/Terms.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import Credits from "../views/Credits.vue";

// TODO Look for lazy loading for routes

const routes = [
	{
		path: "/",
		name: "HomePage",
		component: HomePage
	},
	{
		path: "/credits",
		name: "credits",
		component: Credits
	},
	{
		path: "/privacy-policy",
		name: "privacy_policy",
		component: PrivacyPolicy
	},
	{
		path: "/terms",
		name: "TermPage",
		component: Terms
	},
	{
		path: "/search-mentor",
		name: "SearchMentor",
		component: SearchMentor
	},
	{
		path: "/faq",
		name: "FAQPage",
		component: FAQPage
	},
	{
		path: "/about",
		name: "AboutPage",
		component: AboutPage
	},
	{
		path: "/verify-token",
		name: "VerifyTokenPage",
		component: VerifyTokenPage,
		meta: { requires_visitor: true }
	},
	{
		path: "/register-mentor",
		name: "RegisterMentorPage",
		component: RegisterPage,
		props: { register_as_mentor: true },
		meta: { requires_visitor: true }
	},
	{
		path: "/register-mentee",
		name: "RegisterMenteePage",
		component: RegisterPage,
		props: { register_as_mentor: false },
		meta: { requires_visitor: true }
	},
	{
		path: "/login",
		name: "LoginPage",
		component: LoginPage,
		meta: {	requires_visitor: true }
	},
	{
		path: "/forgot-password",
		name: "ForgotPasswordPage",
		component: ForgotPasswordPage,
		meta: {	requires_visitor: true }
	},
	{
		path: "/change-password",
		name: "ChangePasswordPage",
		component: ChangePasswordPage,
		meta: {	requires_auth: true }
	},
	{
		path: "/rfc",
		name: "RfcBasePage",
		component: RfcBasePage,
		meta: {	requires_auth: true },
		children: [
			{
				path: "verify-mentor",
				name: "VerifyMentorPage",
				component: VerifyMentorPage,
			},
			{
				path: "mentor-analytics",
				name: "MentorAnalyticsPage",
				component: MentorAnalyticsPage,
			},
			{
				path: "all-mentees",
				name: "MenteesPage",
				component: MenteesPage,
			},
			{
				path: "messages/profile_uid=:profile_uid&user_role=:user_role",
				name: "RfcMessages",
				component: RfcMessages,
			}
		]
	},
	{
		path: "/mentor",
		name: "MentorPage",
		component: MentorBasePage,
		meta: { requires_auth: true },

		children: [
			{
				path: "profile/:profile_uid?",
				name: "MentorProfilePage",
				component: MentorProfilePage,
				// Mentees can view the profile too
			},
			{
				path: "profile-settings",
				name: "MentorProfileSettingsPage",
				component: MentorProfileSettingsPage,
				meta: { requires_mentor: true }
			},
			{
				path: "pending-requests",
				name: "MentorPendingRequestsPage",
				component: MentorPendingRequestsPage,
				meta: { requires_mentor: true }
			},
			{
				path: "my-mentees",
				name: "MyMenteesPage",
				component: MyMenteesPage,
				meta: { requires_mentor: true }
			},
			{
				path: "mentor-settings",
				name: "MentorSettingsPage",
				component: MentorSettingsPage,
				props: { is_editable: true },
				meta: { requires_mentor: true }
			},
			{
				path: "messages",
				name: "MentorMessages",
				component: MentorMessages,
				props: { is_editable: true },
				meta: { requires_mentor: true }
			}
		]
	},
	{
		path: "/mentee",
		name: "MenteePage",
		component: MenteeBasePage,
		meta: { requires_auth: true },

		children: [
			{
				path: "profile/:profile_uid?",
				name: "MenteeProfilePage",
				component: MenteeProfilePage,
				// meta: { requires_mentee: true }
			},
			{
				path: "profilerequest/",
				name: "MenteeRequestProfilePage",
				component: MenteeRequestProfilePage,
				// meta: { requires_mentee: true }
			},
			{
				path: "profile-settings",
				name: "MenteeProfileSettingsPage",
				component: MenteeProfileSettingsPage,
				meta: { requires_mentee: true }
			},
			{
				path: "pending-requests",
				name: "MenteePendingRequestsPage",
				component: MenteePendingRequestsPage,
				meta: { requires_mentee: true }
			},
			{
				path: "my-mentors",
				name: "MyMentorsPage",
				component: MyMentorsPage,
				meta: { requires_mentee: true }
			},
			{
				path: "find-mentor",
				name: "FindMentorPage",
				component: FindMentorPage,
				meta: { requires_mentee: true }
			},
			{
				path: "messages",
				name: "MenteeMessages",
				component: MenteeMessages,
				props: { is_editable: true },
				meta: { requires_mentee: true }
			}
		]
	},
	{
		path: "/mentorship/:mentorship_uid",
		name: "MentorshipPage",
		component: MentorshipPage,
		meta: { requires_auth: true }
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requires_auth)) {
		if (!store.getters.logged_in) {
			next({ name: "LoginPage" })
		}
		else if (to.matched.some(record => record.meta.requires_mentor)) {
			if (!store.state.user.is_mentor) {
				next({ name: "HomePage" })
			}
			else {
				next()
			}
		}
		else if (to.matched.some(record => record.meta.requires_mentee)) {
			if (!store.state.user.is_mentee) {
				next({ name: "HomePage" })
			}
			else {
				next()
			}
		}
		else {
			next()
		}
	}
	else if (to.matched.some(record => record.meta.requires_visitor)) {
		if (store.getters.logged_in) {
			next({ name: "HomePage" })
		}
		else {
			next()
		}
	}
	else {
		next()
	}
});

export default router;
